import { makeGraphQLRequest } from 'graphql/makeGraphQLRequest';
import { GET_MACRO_BY_ID_QUERY } from './macroArticle.gql';

export const getMacroById = async (macroId, simplrAccountId) => {
  return await makeGraphQLRequest(
    GET_MACRO_BY_ID_QUERY,
    {
      filter: {
        id: {
          eq: macroId,
        },
        isActive: {
          is: true,
        },
        simplrAccountId: {
          eq: simplrAccountId,
        },
      },
    },
    'macroArticleFindFirst'
  );
};
